import { createClient } from '@launchdarkly/js-client-sdk';
import PubSub from 'pubsub-js';
import GlobalConst from '../utils/GlobalConst';

const reportLaunchDarklyError = error => {
	PubSub.publish(GlobalConst.LAUNCH_DARKLY_ERROR_MSG, error);
};

const anonymousContext = {
	kind: 'user',
	key: 'anonymous',
	anonymous: true
};

const client = createClient(process.env.LD_CLIENT_ID, anonymousContext);

// Exported so consumers can await LD readiness without re-registering 'ready' listeners
export const ldInitPromise = client.start().catch(error => {
	reportLaunchDarklyError(error);
});

let currentIdentityPromise = ldInitPromise;

// Consumers can await the latest identity before evaluating a flag.
export const getLaunchDarklyIdentityPromise = () => currentIdentityPromise;

export const identifyLaunchDarklyUser = user => {
	const userKey = user?.id ? String(user.id) : null;
	const context = userKey ? {
		kind: 'user',
		key: userKey,
		first_name: user.firstName,
		last_name: user.lastName,
		email: user.email
	} : anonymousContext;

	const identityPromise = currentIdentityPromise.then(() => client.identify(context)).catch(error => {
		reportLaunchDarklyError(error);
		throw error;
	});
	currentIdentityPromise = identityPromise.catch(() => {});
	return identityPromise;
};

export default client;
